import { IHasIdAndName } from '../interfaces/has-id-and-name.interface';
import { ICloneAndCopy } from '../interfaces/clone-and-copy';
import { WorkflowPermissionBase } from './workflow-permission-base.model';

export class WorkflowStatePermission extends WorkflowPermissionBase implements ICloneAndCopy {
    public workflowId: number;

    public stateId: number;
    public stateName: string;

    // Implement interface IHasIdAndName.
    public getId(): number {
        return (this.stateId);
    }
    public setId(value: number): void {
        this.stateId = value;
    }

    //public name: string;
    public getName(): string {
        return (this.stateName);
    }
    public setName(nameParam: string): void {
        this.stateName = nameParam;

        return;
    }

    public typeName(): string {
        return ('WorkflowStatePermission');
    }

    // Implement interface ICloneAndCopy.
    public clone(): ICloneAndCopy {
        let clone: WorkflowStatePermission = new WorkflowStatePermission();

        clone.copyFieldsFrom(this);
        clone.workflowId = this.workflowId;
        clone.stateId = this.stateId;
        clone.stateName = this.stateName;

        return (clone);
    }

    public copy(objectToCopy: ICloneAndCopy): void {
        let wsPermission: WorkflowStatePermission = <WorkflowStatePermission>objectToCopy;

        this.copyFieldsFrom(wsPermission);
        this.workflowId = wsPermission.workflowId;
        this.stateId = wsPermission.stateId;
        this.stateName = wsPermission.stateName;

        return;
    }
}
